import { PageHero } from "@/components/site/Bits";
import { useI18n } from "@/i18n/I18nContext";

export default function Legal({ type = "mentions" }) {
  const { t } = useI18n();
  const key = type === "confidentialite" ? "privacy" : "mentions";
  const sections = t(`legal.${key}.sections`);
  return (
    <div>
      <PageHero eyebrow={t(`legal.${key}.eyebrow`)} title={t(`legal.${key}.title`)} />
      <section className="max-w-3xl mx-auto px-5 sm:px-8 pb-24 space-y-8">
        {(Array.isArray(sections) ? sections : []).map(([h, b]) => (
          <div key={h}>
            <h2 className="font-display font-semibold text-xl text-white">{h}</h2>
            <p className="mt-2 text-zinc-400 leading-relaxed">{b}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
